import { RecommendationLocation } from '../RecommendationLocation';

export const shouldOpenAddToBagDrawer = (location: RecommendationLocation): boolean =>
    [
        RecommendationLocation.RDP,
        RecommendationLocation.PDP,
        RecommendationLocation.DRAWER,
        RecommendationLocation.PLP,
        RecommendationLocation.SEARCH_RESULTS,
        RecommendationLocation.SEARCH_NO_RESULTS,
    ].includes(location);
